function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegalHoldArchived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#626262",
      fillOpacity: 1,
      strokeWidth: 1.56264
    },
    fill: "#ad3f16",
    d: "M9.17 43.019 26.966 23.24l-2.21-2.21L4.98 38.83a2.965 2.965 0 0 0-.112 4.3 2.964 2.964 0 0 0 4.3-.112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404040",
      fillOpacity: 1,
      strokeWidth: 1.56264
    },
    fill: "#751b0b",
    transform: "matrix(-.70708 -.70713 -.7071 .7071 0 0)",
    d: "M-43.374-15.136h18.808v11.829h-18.808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      fillOpacity: 1,
      strokeWidth: 1.56264
    },
    fill: "#d6742d",
    d: "m30.838 26.132 8.368-8.368c.6-.6.6-1.572 0-2.172L32.472 8.86c-.6-.6-1.572-.6-2.172 0l-8.367 8.368c-.6.6-.6 1.572 0 2.172l6.733 6.733c.6.6 1.572.6 2.172 0zM19.742 14.998l8.33-8.33c.611-.611.611-1.6 0-2.21a1.56 1.56 0 0 0-2.21 0l-8.33 8.33a1.564 1.564 0 0 0 2.21 2.21zm15.47 15.469 8.33-8.33c.61-.611.61-1.6 0-2.21a1.56 1.56 0 0 0-2.21 0l-8.33 8.33a1.561 1.561 0 0 0 0 2.21 1.56 1.56 0 0 0 2.21 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.84 41.79 7.78 6.73a.337.337 0 0 0-.478 0L5.873 8.16a.337.337 0 0 0 0 .476l35.061 35.062a.337.337 0 0 0 .477 0l1.43-1.43a.338.338 0 0 0 0-.477z",
    fill: "#e52030",
    style: {
      strokeWidth: 0.884895
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalHoldArchived);
export default __webpack_public_path__ + "static/media/legalHoldArchived.1439afdf15bbd683e95ca9c57543286d.svg";
export { ForwardRef as ReactComponent };